import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { handlePurchaseReqUpdateCreate } from "../../../commonHandlerFunction/Purchase/PurchaseReq/PurchaseRequsitionHandler";
import CustomPopupModal from "../../../commonModalForms/CustomPopupModal";
import {
  decryptDataForURL,
  encryptDataForURL,
} from "../../../../../utills/useCryptoUtils";
import {
  handlePOCreatByItems,
  handlePurchaseOrderCreateUpdate,
} from "../../../commonHandlerFunction/Purchase/PurchaseOrder/PurchaseOrderHandler";

const PurchaseRequistionButtons = ({
  formData,
  handleSubmit,
  setIsOverlayLoader,
  status,
  setFormData,
  viewOnly,
  editableIndex,
  setEditableIndex,
  setPopupAddPurchaseReq,
  setTableData,
  section,
  moduleType,
  setIsRejectPopupOpen,
  setIsCancelPopupOpen
}) => {
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.split("?")[1]);
  const req_no = decryptDataForURL(params.get("req_no"));
  const useFor = decryptDataForURL(params.get("useFor"));
  const [isCustomPopup, setIsCustomPopup] = useState(false);
  const handleCustomConfirmHandler = () => {
    handlePurchaseReqUpdateCreate(
      formData,
      handleSubmit,
      setIsOverlayLoader,
      navigate,
      2,
      setFormData,
      setTableData,
      1,
      "",
    );
  };
  let navigate = useNavigate();
  return (
    <div className={moduleType === "PRPreview" ? "submit_btns" : "auditBtns"}>
      {(formData[0]?.req_no || moduleType === "PRPreview") && (
        <Button
          type="button"
          className="cancelBtn"
          onClick={() =>
            navigate(
              moduleType === "PRPreview" ? useFor === "po-dashboard" ? `/po-dashboard` :
                `/PurchRequistion/PurchaseRequistionForm/${encryptDataForURL(req_no)}`
                : -1,
            )
          }
        >
          Back
        </Button>
      )}

      {/* <>

           
                {

                    !viewOnly && formData[0]?.req_status !== "Posted" && formData[0]?.req_status != "Sent for Approval" && formData[0]?.req_status != "Approved" ?
                        <Button
                            type="button"
                            className="submitBtn"
                            onClick={() =>
                                handlePurchaseReqUpdateCreate(formData, handleSubmit, setIsOverlayLoader, navigate, 0, setFormData, setTableData, 1)
                            }
                        >
                            Save
                        </Button> : ""
                }

                {
                    !viewOnly && (
                        (formData[0].req_no || formData[0]?.items?.length)  && (formData[0]?.req_status === "Saved" )
                      ) ?
                        <Button
                            type="button"
                            className="submitBtn"
                            onClick={() =>
                                handlePurchaseReqUpdateCreate(formData, handleSubmit, setIsOverlayLoader, navigate, 1, setFormData, setTableData, 1)
                            }
                        >
                            Post
                        </Button> : ""
                }

                {
                    !viewOnly && formData[0]?.req_status == "Posted" &&
                    <Button
                        type="button"
                        className="submitBtn"
                        onClick={() =>
                            handlePurchaseReqUpdateCreate(formData, handleSubmit, setIsOverlayLoader, navigate, 2, setFormData, setTableData, 1)
                        }
                    >
                        Send for Approval
                    </Button>
                }

                {
                    !viewOnly && formData[0]?.req_status === "Sent for Approval" &&
                    <Button
                        type="button"
                        className="submitBtn"
                        onClick={() =>
                            handlePurchaseReqUpdateCreate(formData, handleSubmit, setIsOverlayLoader, navigate, 3, setFormData, setTableData, 1)
                        }
                    >
                        Approve
                    </Button>
                }
            </> */}

      <>
        {!viewOnly && formData[0]?.items?.length > 0 && (
          <>
            {!["Posted", "Sent for Approval", "Approved", "Reject"].includes(
              formData[0]?.req_status,
            ) && (
                <Button
                  type="button"
                  className="submitBtn"
                  onClick={() =>
                    handlePurchaseReqUpdateCreate(
                      formData,
                      handleSubmit,
                      setIsOverlayLoader,
                      navigate,
                      0,
                      setFormData,
                      setTableData,
                      1,
                      "",
                    )
                  }
                >
                  Save
                </Button>
              )}

            {(((formData[0].req_no || formData[0]?.items?.length > 0) &&
              ["Saved", "Reject"].includes(formData[0]?.req_status)) ||
              useFor === "Edit") && (
                <Button
                  type="button"
                  className="submitBtn"
                  onClick={
                    () =>
                      handlePurchaseReqUpdateCreate(
                        formData,
                        handleSubmit,
                        setIsOverlayLoader,
                        navigate,
                        1,
                        setFormData,
                        setTableData,
                        1,
                        "",
                      )
                    // setIsCustomPopup(true)
                  }
                >
                  Post
                </Button>
              )}

            {formData[0]?.req_status === "Posted" && useFor !== "Edit" && (
              <>
                <Button
                  type="button"
                  className="submitBtn"
                  onClick={() =>
                    // handlePurchaseReqUpdateCreate(formData, handleSubmit, setIsOverlayLoader, navigate, 2, setFormData, setTableData, 1, "")
                    setIsCustomPopup(true)
                  }
                  disabled={formData[0]?.items?.length == 0}
                >
                  Send for Approval
                </Button>
                <Button
                  type="button"
                  className="submitBtn"
                  onClick={() =>
                    navigate(
                      `/PurchRequistion/preview-pdf/${encryptDataForURL(
                        formData[0]?.req_id,
                      )}?req_no=${encryptDataForURL(formData[0]?.req_no)}`,
                    )
                  }
                >
                  Preview PDF
                </Button>
              </>
            )}

            {formData[0]?.req_status === "Sent for Approval" && (
              <>
                <Button
                  type="button"
                  className="submitBtn"
                  onClick={(e) => setIsRejectPopupOpen(true)}
                // onClick={() =>
                //     handlePurchaseReqUpdateCreate(formData, handleSubmit, setIsOverlayLoader, navigate, 3, setFormData, setTableData, 1)
                // }
                >
                  Reject
                </Button>
                <Button
                  type="button"
                  className="submitBtn"
                  onClick={() =>
                    handlePurchaseReqUpdateCreate(
                      formData,
                      handleSubmit,
                      setIsOverlayLoader,
                      navigate,
                      3,
                      setFormData,
                      setTableData,
                      1,
                    )
                  }
                >
                  Approve
                </Button>
                <Button
                  type="button"
                  className="submitBtn"
                  onClick={() => {
                    setIsRejectPopupOpen(true);
                    setIsCancelPopupOpen(true);
                  }}
                >
                  Cancel PR
                </Button>
                <Button
                  type="button"
                  className="submitBtn"
                  onClick={() =>
                    navigate(
                      `/PurchRequistion/preview-pdf/${encryptDataForURL(
                        formData[0]?.req_id,
                      )}?req_no=${encryptDataForURL(formData[0]?.req_no)}`,
                    )
                  }
                >
                  Preview PDF
                </Button>
              </>
            )}
            {useFor === "CreatePO" && (
              <>
                <Button
                  type="button"
                  className="submitBtn"
                  disabled={
                    !formData?.[0]?.selectedTableRows ||
                    formData?.[0]?.selectedTableRows?.length === 0
                  }
                  onClick={() => {
                    handlePOCreatByItems(
                      {
                        fk_req_id: formData[0]?.req_id,
                        po_status: "Received",
                        po_prd_items: formData?.[0]?.selectedTableRows,
                      },
                      setIsOverlayLoader,
                      navigate,
                      1,
                    );
                  }}
                >
                  Create PO
                </Button>
              </>
            )}
          </>
        )}
      </>
      {isCustomPopup && (
        <CustomPopupModal
          isCustomPopup={isCustomPopup}
          setIsCustomPopup={setIsCustomPopup}
          handleConfirm={() => handleCustomConfirmHandler()}
          formData={formData}
          setFormData={setFormData}
          section={section.customField}
          moduleType={moduleType}
        />
      )}
    </div>
  );
};

export default PurchaseRequistionButtons;
